import './styles.scss'

export default function IconSearch() {
  return (
    <svg
      width="34"
      height="31"
      viewBox="0 0 34 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.6896 18.4474C29.6896 17.648 29.0415 17 28.2422 17C27.4428 17 26.7948 17.648 26.7948 18.4474V21.0526L24.1896 21.0526C23.3902 21.0526 22.7422 21.7006 22.7422 22.5C22.7422 23.2994 23.3902 23.9474 24.1896 23.9474L26.7948 23.9474V26.5526C26.7948 27.352 27.4428 28 28.2422 28C29.0415 28 29.6896 27.352 29.6896 26.5526V23.9474L32.2948 23.9474C33.0942 23.9474 33.7422 23.2994 33.7422 22.5C33.7422 21.7006 33.0942 21.0526 32.2948 21.0526L29.6896 21.0526V18.4474Z"
        fill="#2D4040"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7837 23.3672C14.6754 23.3672 10.5342 19.2261 10.5342 14.1177C10.5342 9.00932 14.6754 4.86817 19.7837 4.86817C24.8528 4.86817 28.9695 8.94587 29.0325 14H33.901C33.8377 6.2572 27.5415 0 19.7837 0C11.9868 0 5.66605 6.32071 5.66605 14.1177C5.66605 16.3116 6.16649 18.3887 7.05946 20.2409C6.75019 20.3643 6.45607 20.5409 6.1906 20.7717L1.04616 25.2452C-0.221867 26.3478 -0.35595 28.2696 0.746684 29.5376C1.84932 30.8057 3.77112 30.9397 5.03915 29.8371L10.1836 25.3637C10.3559 25.2138 10.5073 25.0488 10.6375 24.8724C13.1012 26.9697 16.2947 28.2354 19.7837 28.2354C20.1069 28.2354 20.4275 28.2245 20.7452 28.2032V23.3178C20.4292 23.3505 20.1084 23.3672 19.7837 23.3672Z"
        fill="#2D4040"
      />
    </svg>
  )
}
